import { Typography } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import React from 'react';

import * as S from './style';

function Chart({ chartOptions, chartSeries, title, subtitle }) {
  return (
    <S.ChartWrapper>
      <S.ChartHeader>
        <Typography variant="body2Bold">{title}</Typography>
        <Typography variant="caption1" emphasis="weak">
          {subtitle}
        </Typography>
      </S.ChartHeader>
      <S.StyledChart options={chartOptions} series={chartSeries} type="bar" height={220} />
    </S.ChartWrapper>
  );
}

Chart.propTypes = {
  chartOptions: PropTypes.object.isRequired,
  chartSeries: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired
};

export { Chart };
